/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { Link } from 'react-router';
import styles from './styles.scss';

const defaultProps = {
  tools: [' '],
};

const propTypes = {
  tools: React.PropTypes.array.isRequired,
};

class PanelToolbar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
    };
  }

  render() {
    const { collapsed } = this.state;
    const tools = this.props.tools.map((tool, idx) => (
      <li key={String(idx)}>{tool}</li>
    ));
    return (
      <div className={`${styles.toolbar} ${collapsed ? styles.collapsed : ''}`}>
        <ul className={styles.tools}>
          {tools}
        </ul>
        <Link
          className={styles.toggle}
          onClick={() => { this.setState({ collapsed: !collapsed }); }}
        >
          <i className={`fa fa-caret-left ${styles.arrow}`} />
        </Link>
        <div style={{ clear: 'both' }} />
      </div>
    );
  }
}

PanelToolbar.defaultProps = defaultProps;
PanelToolbar.propTypes = propTypes;

export default PanelToolbar;




// WEBPACK FOOTER //
// ./src/components/PanelToolbar/index.jsx